import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;

const api = axios.create({
  baseURL: `${BASE}/api`,
  withCredentials: true,
});

// centralize error message formatting for React-safe rendering
export function formatApiErrorDetail(detail) {
  if (detail == null) return "Bir hata oluştu, lütfen tekrar deneyin.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

// Extract the best possible human-readable error from an axios error.
// Distinguishes network failures ("no response") from server errors so users
// see something useful instead of a generic fallback.
export function extractError(err, fallback = "Bir hata oluştu, lütfen tekrar deneyin.") {
  if (!err) return fallback;
  if (err.response) {
    const detail = err.response.data?.detail;
    if (detail) return formatApiErrorDetail(detail);
    if (err.response.status === 401) return "E-posta veya parola hatalı.";
    if (err.response.status === 403) return "Bu işlem için yetkiniz yok.";
    if (err.response.status === 429) return "Çok fazla başarısız deneme. Lütfen birkaç dakika sonra tekrar deneyin.";
    if (err.response.status >= 500) return "Sunucuda bir sorun oluştu. Lütfen tekrar deneyin.";
    return fallback;
  }
  if (err.request) {
    return "Sunucuya ulaşılamıyor. İnternet bağlantınızı kontrol edin veya sayfayı yenileyin.";
  }
  if (err.message) return err.message;
  return fallback;
}

export default api;
